import { defineStore } from 'pinia'
import { generateNewQuotation, getOportunitiesStatuses, updateQuotationStatus } from '../core/requests/Oportunities'
import { useToast } from 'vuestic-ui/web-components'

const { notify } = useToast()

export const useOportunitiesStore = defineStore('oportunities', {
  state: (): any => {
    return {
      showConfirm: false,
      cancelStatus: false,
      isOnChangeStatus: false,
      isLoading: false,
      activeOportunity: null,
      statusOptions: [],
    }
  },

  getters: {
    vailable(): any {
      return this.cancelStatus
    },
  },

  actions: {
    async getQuotationStates() {
      const _ = localStorage.getItem('quotation_satus') ?? ''
      const _data = _ && JSON.parse(_)
      if (!_data) {
        const statuses: any = await getOportunitiesStatuses()
        this.statusOptions = statuses.map((i: any) => ({
          label: i.name,
          id: i.order,
        }))
        localStorage.setItem('quotation_satus', JSON.stringify(this.statusOptions))
      } else {
        this.statusOptions = _data
      }
    },
    async doGenerateQuotation() {
      try {
        this.isOnChangeStatus = true

        await generateNewQuotation({}, this.activeOportunity.id).then((response: any) => {
          console.log(response)
        })

        notify({
          message: 'Se ha generado la cotización.',
          color: 'success',
          duration: 1000,
        })

        this.activeOportunity = null
        this.isOnChangeStatus = false

        this.hideConfirm()
      } catch (error) {
        // register log
        this.hideConfirm()
      }
    },
    async doChangeStatus() {
      try {
        this.isOnChangeStatus = true

        const body = {
          status: this.activeOportunity.status,
          status_label: this.statusOptions.find((f: any) => f.id === this.activeOportunity.status)?.label,
        }

        await updateQuotationStatus(
          {
            ...body,
            ...(body.status === 4 && {
              comment: this.activeOportunity.comments,
              finalPrice: this.activeOportunity.total,
            }),
          },
          this.activeOportunity.id,
        )

        notify({
          message: 'El estado de la cotización #' + this.activeOportunity.id + ' se ha actualizado.',
          color: 'success',
          duration: 1000,
        })

        this.activeOportunity.final_price = this.activeOportunity.total

        if (this.activeOportunity) {
          this.activeOportunity.state = this.activeOportunity.status
        }

        this.activeOportunity = null

        this.isOnChangeStatus = false

        this.hideConfirm()
      } catch (error) {
        // register log
        this.hideConfirm()
      }
    },
    setActiveOportunity(oportunity: any) {
      this.activeOportunity = oportunity
    },
    viewConfirm() {
      this.cancelStatus = true
      this.showConfirm = true
    },
    hideConfirm() {
      this.showConfirm = false
      this.cancelStatus = false
      if (this.activeOportunity) {
        this.activeOportunity.status = this.activeOportunity.state
      }

      this.activeOportunity = null
    },
  },
})
